/**
 * @since 2023-07-31
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import ButtonBlue from "components/Shared/ButtonBlue";
import SectionScoresError from "components/Shared/SectionScoresError";
import TableScoresWithFilters from "components/Shared/TableScoresWithFilters";
import TextCopyright from "components/Shared/TextCopyright";
import TextWait from "components/Shared/TextWait";
import {
  createPortfolioAnalysis,
  getStatusPortfolioAnalysis,
  loadPortfolioScores,
  waitForPortfolioAnalysis,
} from "dataHandling/portfolio";
import { useEffect, useState } from "react";

const PanelScores = ({ email, portfolioId, onReportsClick }) => {
  //region States

  const [status, setStatus] = useState("");
  const [scoresTable, setScoresTable] = useState(null);

  //endregion

  //region Use Effects

  useEffect(() => {
    fetchData();
  }, [portfolioId, email]);

  //endregion

  //region Methods

  const fetchData = async () => {
    if (!portfolioId) return;
    let newStatus = await getStatusPortfolioAnalysis(email, portfolioId);
    if (newStatus === "WAITING") {
      setStatus(newStatus);
      newStatus = await waitForPortfolioAnalysis(email, portfolioId);
    }
    if (newStatus === "OK") {
      const newScoresTable = await loadPortfolioScores(email, portfolioId);
      setScoresTable(newScoresTable);
    }
    setStatus(newStatus);
  };

  const startScoresAnalysis = async () => {
    setStatus("WAITING");
    await createPortfolioAnalysis(email, portfolioId);
    fetchData();
  };

  //endregion

  return (
    <>
      {status === "NEW" && (
        <ButtonBlue
          label="CREATE SCORES"
          alignment="left"
          onClick={startScoresAnalysis}
        />
      )}
      {status === "WAITING" && <TextWait />}
      {status === "ERROR" && (
        <SectionScoresError onClick={startScoresAnalysis} />
      )}
      {status === "OK" && (
        <>
          <TableScoresWithFilters
            scoresTable={scoresTable}
            showRecommendations={true}
          />
          <br />
          <br />
          <ButtonBlue label="SEE REPORTS" onClick={onReportsClick} />
          <TextCopyright />
        </>
      )}
    </>
  );
};

export default PanelScores;
